<app-multiple-select-filter-simple
    [parentFormGroup]="parentFormGroup"
    [parentFormControlName]="parentFormControlName"
    [elements]="elements"
    [loading]="findAllService.loading$ | async"
    (selectionChangedEvent)="selectionChangeEvent.emit($event)">
</app-multiple-select-filter-simple>
